import { UsersParams } from '../../../../interfaces/Auth';

export const getUsersUrl = (params: UsersParams) => {
  const { email, aktiv, page, size, sort, role } = params;
  let queryString = `/perdorues?size=${size}&page=${page}&sort=emriPersoni:asc`;

  if (aktiv !== undefined) {
    queryString += `&filter=aktiv:eq:${aktiv}`;
  }
  if (email) {
    queryString += `&filter=emriPersoni:ilike:${email}`;
  }
  if (sort) {
    queryString += `&sort=dataKrijimit:${sort}`;
  }

  if (role && role.length > 0) {
    queryString += `&filter=rolet:eq:${role}`;
  }

  return queryString;
};
